// ──────────────────────────────────────────────
// GeoDrops — Loading / Error States
// Neon Navigator design system.
// ──────────────────────────────────────────────

interface LoadingScreenProps {
  message: string;
}

export function LoadingScreen({ message }: LoadingScreenProps) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        background: "var(--tg-bg, #020a2f)",
        color: "var(--tg-text, #e1e4ff)",
        padding: 32,
        textAlign: "center",
      }}
    >
      <div
        style={{
          width: 44,
          height: 44,
          border: "3px solid var(--geo-surface-high, #0e1b4c)",
          borderTopColor: "var(--geo-primary, #85adff)",
          borderRadius: "50%",
          animation: "spin 0.8s linear infinite",
          marginBottom: 20,
          boxShadow: "0 0 20px rgba(133,173,255,0.2)",
        }}
      />
      <p style={{
        fontSize: 14,
        color: "var(--tg-hint, #6b739d)",
        fontFamily: "var(--font-body, Inter, sans-serif)",
        fontWeight: 500,
        letterSpacing: "0.02em",
        textTransform: "uppercase",
      }}>
        {message}
      </p>
    </div>
  );
}

interface ErrorScreenProps {
  message: string;
  onRetry?: () => void;
}

export function ErrorScreen({ message, onRetry }: ErrorScreenProps) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        background: "var(--tg-bg, #020a2f)",
        color: "var(--tg-text, #e1e4ff)",
        padding: 32,
        textAlign: "center",
      }}
    >
      <div style={{
        width: 64,
        height: 64,
        borderRadius: "50%",
        background: "var(--geo-surface-high, #0e1b4c)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: 28,
        marginBottom: 20,
        boxShadow: "0 12px 32px rgba(0,0,0,0.4)",
      }}>
        &#128205;
      </div>
      <p style={{
        fontSize: 18,
        fontWeight: 700,
        fontFamily: "var(--font-headline, 'Plus Jakarta Sans', sans-serif)",
        marginBottom: 8,
      }}>
        Oops
      </p>
      <p style={{
        fontSize: 14,
        color: "var(--tg-hint, #6b739d)",
        marginBottom: 28,
        maxWidth: 280,
        lineHeight: 1.6,
      }}>
        {message}
      </p>
      {onRetry && (
        <button
          onClick={onRetry}
          style={{
            padding: "14px 36px",
            borderRadius: 9999,
            border: "none",
            background: "linear-gradient(135deg, #85adff, #6c9fff)",
            color: "#002c65",
            fontSize: 15,
            fontWeight: 700,
            cursor: "pointer",
            boxShadow: "0 8px 20px rgba(133,173,255,0.3)",
            transition: "transform 0.15s",
          }}
        >
          Try Again
        </button>
      )}
    </div>
  );
}
